<template>
	<!-- 顶部导航栏 -->
	<header class="top-nav" id="top-nav">
		<div class="nav-container">
			<div class="logo" @click="$router.replace({path: '/'})">
				<img src="../assets/logo.png" alt="岱屿画境">
			</div>
			<nav class="main-nav">
				<router-link to="/super-talk-community" exact>超话社区</router-link>
				<router-link to="/creator-flower-market">创作者花市</router-link>
				<router-link to="/wonderful-activities">精彩活动</router-link>
				<router-link to="/surrounding-markets">周边市场</router-link>
				<router-link to="/creator-center">创作者中心</router-link>
			</nav>
		</div>
		<div class="nav-search-login-register">
			<div class="nav-search" @click="searchPop = true">
				<img class="search-icon" src="../assets/search.png" alt="搜索">
				<input type="text" placeholder="请输入作品关键字快速搜索作品…" readonly>
			</div>
			<div class="userInfo" v-if="userId">
				<el-popover placement="bottom" trigger="hover">
					<div class="logoutBox"
						style="width: 1.36rem;background: #FFFFFF;display: flex;flex-direction: column;align-items: center;">
						<img class="logoutAvatar"
							style="width: .64rem;height: .64rem;border-radius: 50%;object-fit: cover;"
							:src="userInfo.avatar" v-if="userInfo.avatar" />
						<img class="logoutAvatar"
							style="width: .64rem;height: .64rem;border-radius: 50%;object-fit: cover;"
							src="../assets/defaultAvatar.png" v-else />
						<div class="userName"
							style="margin-top: .12rem;font-weight: 500;font-size: .16rem;color: #252525;line-height: .24rem;">
							{{userInfo.user_nickname}}
						</div>
						<div class="userId"
							style="margin-top: .02rem;font-weight: 400;font-size: .12rem;color: #666666;">
							NO.{{userInfo.tj_num}}</div>
						<div class="logout"
							style="margin-top: .24rem;width: 1.08rem;height: .36rem;border-radius: .06rem;border: .01rem solid #E29358;font-weight: 400;font-size: .14rem;color: #E29358;text-align: center;line-height: .36rem;cursor: pointer;"
							@click="logout">
							退出登录</div>
					</div>
					<div class="avatarBox" slot="reference">
						<img class="avatar" :src="userInfo.avatar" v-if="userInfo.avatar" />
						<img class="avatar" src="../assets/defaultAvatar.png" v-else />
					</div>
				</el-popover>
				<div class="personalCenter">
					<router-link to="/personal-center">个人中心</router-link>
				</div>
			</div>
			<div class="nav-login-register" v-else>
				<div class="nav-login">
					<router-link to="/login">登录</router-link>
				</div>
				<div class="nav-register">
					<router-link to="/register">注册</router-link>
				</div>
			</div>
		</div>
		<div class="searchPop" v-if="searchPop" @click="searchPop = false">
			<div class="centerContent" @click.stop="">
				<input type="text" v-model="keywords" placeholder="请输入搜索内容" />
				<div class="search" @click="naviToCreatorFlowerMarket">搜索</div>
			</div>
		</div>
	</header>
</template>

<script>
	export default {
		name: 'TopNavBar',
		data() {
			return {
				keywords: '',
				userInfo: {},
				searchPop: false,
				userId: '',
			}
		},
		mounted() {
			if (localStorage.getItem('token')) {
				this.userId = localStorage.getItem('userId')
				this.userDetails()
			}
		},
		methods: {
			userDetails() {
				this.$api.post('/UserD/user_details', {}).then(res => {
					if (res.code == 1) {
						this.userInfo = res.data
					} else {
						console.log(res.msg)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			naviToCreatorFlowerMarket() {
				this.$router.push({
					path: '/creator-flower-market',
					query: {
						keywords: this.keywords
					}
				})
				this.searchPop = false
				this.keywords = ''
			},
			logout() {
				localStorage.clear();
				this.$store.dispatch('updateShopStatus', 1)
				this.$router.replace({
					path: '/login'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	/* 顶部导航栏样式 */
	.top-nav {
		position: sticky;
		top: 0;
		height: .8rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #FAEFDD;
		box-shadow: inset 0px 0px 0px 0px rgba(126, 62, 11, 0.15);
		z-index: 99;
	}

	.nav-container {
		max-width: 12rem;
		margin-left: 1.2rem;
		display: flex;
		align-items: center;
		height: .8rem;
	}

	.logo {
		display: flex;
		width: 1.5rem;
		height: .3rem;
		margin-right: 1.04rem;
		cursor: pointer;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.main-nav {
		display: flex;
		align-items: center;
		gap: .7rem;
	}

	.main-nav a {
		text-decoration: none;
		font-weight: 500;
		font-size: .16rem;
		color: #000000;
		transition: color 0.3s;
	}

	.main-nav a:hover {
		color: #6B3503;
	}

	.main-nav .router-link-active {
		color: #6B3503;
		font-weight: 600;
		position: relative;
	}

	.main-nav .router-link-active::after {
		content: '';
		position: absolute;
		bottom: -8px;
		left: 0;
		width: 100%;
		height: 2px;
		background-color: #6B3503;
	}

	.nav-search-login-register {
		display: flex;
		align-items: center;
	}

	.nav-search {
		display: flex;
		align-items: center;
		cursor: pointer;

		.search-icon {
			width: .2rem;
			height: .2rem;
			margin-right: .08rem;
		}

		input {
			width: 2.5rem;
			font-weight: 400;
			font-size: .16rem;
			padding: 0 0;
			border: none;
			outline: none;
			background-color: transparent;
		}
	}

	.userInfo {
		display: flex;
		align-items: center;

		.avatar {
			width: .4rem;
			height: .4rem;
			border-radius: 50%;
			object-fit: cover;
			cursor: pointer;
		}

		.personalCenter {
			margin-left: .36rem;
			margin-right: 1.2rem;
			width: 1.1rem;
			height: .52rem;
			background: #E29358;
			border-radius: .04rem;
			font-weight: 500;
			font-size: .14rem;
			color: #252525;
			line-height: .52rem;
			text-align: center;

			a {
				display: inline-block;
				width: 1.1rem;
				line-height: .52rem;
				color: #252525;
			}

			a:hover {
				text-decoration: none;
			}
		}
	}

	.nav-login-register {
		display: flex;
		align-items: center;

		.nav-login,
		.nav-register {
			width: 1.56rem;
			height: .8rem;
			font-weight: 400;
			font-size: .16rem;
			color: #252525;
			text-align: center;
			line-height: .8rem;
			cursor: pointer;

			a {
				display: inline-block;
				color: #252525;
				width: 1.56rem;
				line-height: .8rem;
			}

			a:hover {
				text-decoration: none;
			}
		}

		.nav-login {
			background: #EFD8B8;
		}

		.nav-register {
			background: #E29358;
		}
	}

	.searchPop {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.5);
		z-index: 1;

		.centerContent {
			width: 7.4rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background: #FFFFFF;
			border-radius: .12rem;

			input {
				margin-left: .2rem;
				width: 5.72rem;
				height: .74rem;
				font-weight: 500;
				font-size: .18rem;
				padding: 0 0;
				border: none;
			}

			.search {
				width: 1.2rem;
				height: .74rem;
				background: #E29358;
				border-radius: .12rem;
				line-height: .74rem;
				text-align: center;
				cursor: pointer;
			}
		}
	}
</style>
<style>
	.el-popover {
		min-width: unset !important;
		padding: .24rem 0 .2rem !important;
	}
</style>